module.exports = __webpack_public_path__ + "images/pc-top-dark.c35e56bd.png";